module.exports = __webpack_public_path__ + "img/book_more.c06d23f2.svg";